import React from 'react';

const isSessionPaymentReturn = () => {
    if (typeof window === 'undefined' || window.location.pathname !== '/payments/ccbill/approved') {
        return false;
    }

    try {
        const context = JSON.parse(window.localStorage.getItem('privaposts:ccbill-return-context'));
        const reference = new URLSearchParams(window.location.search).get('X-orderRef')
            || new URLSearchParams(window.location.search).get('orderRef');

        return context?.purchase_type === 'SESSION' && context?.reference === reference;
    } catch (error) {
        return false;
    }
};

const ApplicationLoader = () => {
    const isCcbillApproval = typeof window !== 'undefined'
        && ['/payments/ccbill/approved', '/payments/ccbill/subscriptions/approved'].includes(window.location.pathname);
    const isSessionReturn = isSessionPaymentReturn();

    return (
        <div
            className="privaposts-application-loader"
            role="status"
            aria-live="polite"
            aria-label={isCcbillApproval ? 'Confirming your payment' : 'Loading Privaposts'}
        >
            <div className="privaposts-application-loader__content">
                <img
                    className="privaposts-application-loader__logo"
                    src="/images/privaposts_220.png"
                    alt="Privaposts"
                />
                <span className="privaposts-application-loader__dots" aria-hidden="true">
                    <span className="privaposts-application-loader__dot" />
                    <span className="privaposts-application-loader__dot" />
                    <span className="privaposts-application-loader__dot" />
                </span>
                {isCcbillApproval ? (
                    <div className="privaposts-application-loader__payment">
                        <h1>Confirming your payment</h1>
                        <p>{isSessionReturn
                            ? "Your secure checkout has returned to Privaposts. We're verifying your payment and confirming your Session booking."
                            : "Your secure checkout has returned to Privaposts. We're verifying your payment and confirming your purchase."}</p>
                        <p className="privaposts-application-loader__payment-status">Waiting for secure payment confirmation…</p>
                        <p>{isSessionReturn
                            ? "Please don't make another payment while we check your booking."
                            : "Please don't make another payment while we check your purchase."}</p>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ApplicationLoader;
